document.addEventListener('DOMContentLoaded', () => {
  // ========================================
  // 1️⃣ Form-Submit Tracking (Produktseite)
  // ========================================
  document.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
    form.addEventListener('submit', event => {
      try {
        const formData = new FormData(form);
        const variantId = String(formData.get('id') || '').trim();
        const quantity  = parseInt(formData.get('quantity') || '1', 10) || 1;
        const productTitle =
          form.dataset.productTitle ||
          form.closest('.ip-featured-product, .ip-latest-product')?.querySelector('.ip-featured-product__title, .ip-latest-product__title')?.innerText?.trim() ||
          document.querySelector('h1.product__title, .product-title')?.innerText?.trim() ||
          document.title;
        
        let sku = (window.variantSKUs && variantId) ? window.variantSKUs[variantId] : null;
        if (!sku) {
          sku =
            form.dataset.sku ||
            form.querySelector('[name="sku"]')?.value ||
            document.querySelector('#tracking-sku')?.dataset?.sku ||
            'unbekannt';
        }
        sku = String(sku).trim();
        
        let sessionId = localStorage.getItem('cart_session_id');
        if (!sessionId) {
          sessionId = crypto.randomUUID();
          localStorage.setItem('cart_session_id', sessionId);
        }
        
        // Fire and forget
        fetch('https://wawi.sk-shop24.de/srv/tracking/add_to_cart', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            sku,
            variant_id: variantId,
            quantity,
            product_title: productTitle,
            session_id: sessionId,
            source: 'form_submit'
          })
        })
        .catch(err => console.warn('⚠️ Tracking Add-to-Cart fehlgeschlagen:', err));
      } catch (err) {
        console.warn('⚠️ Tracking Add-to-Cart Fehler:', err);
      }
    }, { passive: true });
  });

  // ========================================
  // 2️⃣ AJAX-Cart Tracking (Quick-Add, Drawer)
  // ========================================
  const originalFetch = window.fetch;
  window.fetch = function(...args) {
    const [resource, config] = args;
    const url = typeof resource === 'string' ? resource : resource.url;
    
    // Nur /cart/add.js Requests tracken
    if (url && (url.includes('/cart/add') || url.includes('/cart/add.js'))) {
      try {
        const body = config?.body ? JSON.parse(config.body) : {};
        const variantId = String(body.id || body.variant_id || '').trim();
        const quantity = parseInt(body.quantity || '1', 10) || 1;
        
        if (variantId) {
          let sku = (window.variantSKUs && variantId) ? window.variantSKUs[variantId] : null;
          if (!sku) {
            sku = document.querySelector('[data-sku-' + variantId + ']')?.dataset?.sku || 'unbekannt';
          }
          sku = String(sku || 'unbekannt').trim();
          
          const productTitle = 
            document.querySelector('h1.product__title, .product-title, [data-product-title]')?.innerText?.trim() ||
            document.title;
          
          let sessionId = localStorage.getItem('cart_session_id');
          if (!sessionId) {
            sessionId = crypto.randomUUID();
            localStorage.setItem('cart_session_id', sessionId);
          }
          
          // Fire and forget
          fetch('https://wawi.sk-shop24.de/srv/tracking/add_to_cart', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              sku,
              variant_id: variantId,
              quantity,
              product_title: productTitle,
              session_id: sessionId,
              source: 'ajax_cart'
            })
          })
          .catch(err => console.warn('⚠️ AJAX Tracking fehlgeschlagen:', err));
        }
      } catch (err) {
        console.warn('⚠️ AJAX Tracking Fehler:', err);
      }
    }
    
    // Original fetch aufrufen
    return originalFetch.apply(this, args);
  };
});
